/*
 * Generate url for search component to determine whether to route user
 * to Speedy sell ticket, Foobunny sell ticket, or speedy search results
 * Inputs:
 * webURI - Details url information with SEO and event id info (string)
 */
export const getSellSearchSuggestEventUrl = (webURI) => {
  const tokens = webURI.split('/');
  const formatSearchTerm = tokens && tokens.length > 0 ? tokens[0].replace('-tickets', '').replace(/-/g, '%20') : '';
  const validEventToken = tokens && tokens.length > 2 && tokens[1] === 'event';

  if (validEventToken) {
    return `sell/sellTicket?eventIds=${tokens[2]}`;
  }
  if (tokens && tokens.length > 2) {
    return `sell/searchEvent?id=${tokens[2]}&type=${tokens[1]}&q=${formatSearchTerm}`;
  }

  return 'sell/';
};

/*
 * Generate URL for selling a specific event.
 *
 * @param {string} [eventId] - The ID of the event to sell.
 * @returns {string} - The generated URL for selling the event.
 */
export const getSellEventUrl = (eventId) => {
  const sellEventUrl = eventId ? `sell/sellTicket?eventIds=${eventId}` : 'sell/';

  return sellEventUrl;
};
